<template>
  <section>
    <div class="monitoring_wrp">
      <div class="col-md-12 city_dropdown">
        <div v-if="!cityAdmin" class="col-md-4">
          <div class="row">
            <!-- <h4>Select City</h4> -->
            <!-- <div class="city_rel_class c-pointer">
              <multiselect v-model="city" deselect-label="" track-by="value" label="name" placeholder="Select city"
                :options="cityList" :searchable="true" :allow-empty="false" @select="onCitySelect">
              </multiselect>
            </div> -->
          </div>
        </div>
        <div>
          <!-- <button class="btn gradientbt" @click="resetLocationService()">Reset</button> -->
        </div>
      </div>
      <div class="col-md-12" >
        <div class="col-md-6 map-view">
          <locationTracking />
        </div >
          <div class="col-md-6">
            <v-server-table ref="surveyTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
              <template slot="beforeBody">
                <tr v-if="loading" class="VueTables__no-results">
                  <td class="text-center" colspan="9">
                    <pulse-loader></pulse-loader>
                  </td>
                </tr>
              </template>
            </v-server-table>


          <!-- <h4>Surveyors</h4> -->
          <!-- <div class="large-12 columns subcattable monitor">
            <table class="test-table">
              <thead>
                <tr>
                  <th>Surveyor Name</th>
                  <th>Contact Number</th>
                  <th>Last Updated</th>
                </tr>
              </thead>
              <tbody v-if="surveyorList.length != 0">
                <tr v-for="(item, index) in surveyorList" :key="index">
                  <td>
                    {{ item.surveyorDetails.firstName + " " + item.surveyorDetails.lastName }}
                  </td>
                  <td>{{ item.surveyorDetails.mobile }}</td>
                  <td>
                    {{
                      item.lastStatus ? item.lastStatus : "--"
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody v-if="surveyorList.length == 0">
              <tr>
                <td colspan="6">
                  <div class="text-center"> No Records Found </div>
                </td>
              </tr>
            </tbody>
            </table>
          </div> -->
        </div>
      </div>
      <!-- <div class="col-md-12 driver-data">
        <h4>Trips</h4>
        <div class="large-12 columns subcattable monitor">
          <table class="test-table">
            <thead>
              <tr>
                <th>Driver Name</th>
                <th>Driver Contact Number</th>
                <th>Vehicle Details</th>
                <th>Helper Name</th>
                <th>Helper Contact Number</th>
                <th>Last Updated</th>
              </tr>
            </thead>
            <tbody v-if="driverList.length != 0">
              <tr v-for="(item, index) in driverList" :key="index">
                <td class="c-pointer" v-on:click="getLocationByStaffId(item)">
                  {{ item.driverDetails.firstName + " " + item.driverDetails.lastName }}
                </td>
                <td>{{ item.driverDetails.mobile }}</td>
                <td>{{ item.vehicleDetails ? item.vehicleDetails.vModelName + '(' + item.vehicleDetails.vNumber + ')' : '--'}}</td>
                <td>{{ item.helperDetails ? item.helperDetails.firstName + ' ' + item.helperDetails.lastName : '--' }}</td>
                <td>{{ item.helperDetails ? item.helperDetails.mobile : '--'}}</td>
                <td>{{item.lastStatus ? item.lastStatus : '--'}}</td>
              </tr>
            </tbody>
            <tbody  v-if="driverList.length == 0">
              <tr>
                <td colspan="6">
                  <div class="text-center"> No Records Found </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import locationTracking from "../gmapLocation/tracking.vue";
import { eventBus, dutyTrackingService } from "../../../services";
import dateFormatter from "../../utilities/dateFormate";

export default {
  name: "monitoring",
  components: {
    locationTracking,
  },
  data() {
    return {
      loading: false,
      cityAdmin: false,
      driverList: [],
      surveyorList: [],
      surveyTable: null,
      parameters: {},
      city: {},
      staffLocationRefresh: null,
      columns: ["surveyorName", "contact", "lastUpdate"],

      options: {
        heightlighted: true,
        headings: {
          surveyorName: "Surveyor Name",
          contact: "Contact",
          lastUpdate: "Last Update",
        },
        perPage: 10,
        sortable: ["surveyorName","contact","lastUpdate"],
        requestFunction: (request) => {
          this.parameters.page = request.page;
          this.parameters.limit = request.limit;
        
          if (request.query) {
                this.parameters.searchString = request.query.trim();
            } 
            else {
                      delete this.parameters.searchString;
                  }
          if (request.orderBy) {
            if (request.orderBy == "surveyorName") {
              this.parameters.sortBy = "surveyorDetails.firstName"
            }
            if(request.orderBy == "contact"){
              this.parameters.sortBy = "surveyorDetails.mobile"
            }
            if(request.orderBy == "lastUpdate"){
              this.parameters.sortBy = "details.updatedAt"
            }
            if (request.ascending == 1) {
                this.parameters.sortOrder = "asc";
            } else {
                this.parameters.sortOrder = "dsc";
            }
          }
          
          // if(this.parameters.cityId){
            return dutyTrackingService.dutyMonitoring(this.parameters).catch((error) => {
            console.error("trip.requestFunction-error:", error);
            this.$snotify.error("Get surveyor List", "Error!");
          });
          // }
         
        },
        responseAdapter: (response) => {
          this.loading = false;
          let dataResponse = [];
          let count;
          response.data.response.forEach(el=>{

            if(el.role == "surveyor"){
                let surveyRecord = el
                surveyRecord["surveyorName"] = el.surveyorDetails ?  el.surveyorDetails.firstName + " " + el.surveyorDetails.lastName : "--"
                surveyRecord["contact"] = el.surveyorDetails && el.surveyorDetails.mobile ? el.surveyorDetails.mobile : "--"
                surveyRecord["lastUpdate"] = el.details.updatedAt ? dateFormatter(el.details.updatedAt) : "--"
                dataResponse.push(surveyRecord)
            }
          })

          if (dataResponse.length === 0) {
            count = 0;
          }
          return {
            data: dataResponse,
            count: response.data.totalCount || count,
          };
        },

        customFilters: [{
          name: "custom_filter",
          callback: function (row, query) {
            //	return row.role[0] == query;
          },
        },],
        uniqueKey: "_id",
      },
    };
  },
  methods: {

    getOnDutyStaffList(cityId) {
  
      let dutyInfo = [];
      this.surveyorList = [];
      this.driverList = [];
      this.parameters.cityId = cityId
    
      return dutyTrackingService
        .dutyMonitoring(this.parameters)
        .then((res) => {
          res.data.response.forEach((element) => {
            if (element.details.geoLocation.length > 0 && element.role == 'surveyor' ) {
              let staff = element;
              staff["location"] = {};
              staff["location"]["lat"] = element.details.geoLocation[1] ? element.details.geoLocation[1] : "";
              staff["location"]["lng"] = element.details.geoLocation[0];
              staff["lat"] = element.details.geoLocation[1] ? element.details.geoLocation[1] : "";
              staff["lng"] = element.details.geoLocation[0];
              dutyInfo.push(staff);
              
              // if (element.role == "surveyor") {
              //   let surveyorData = element;
              //   surveyorData['lastStatus'] = element.details.updatedAt ? dateFormatter(element.details.updatedAt) : '--'
              //   this.surveyorList.push(surveyorData);
              // }else if(element.role == "driver"){
              //   let driverData = element;
              //   driverData['lastStatus'] = element.details.updatedAt ? dateFormatter(element.details.updatedAt) : '--'
              //   this.driverList.push(driverData);
              // }
            }
          });
          // if (dutyInfo.length > 0) {
            if (res.data.response != '') {
            eventBus.$emit("trackingLocation", dutyInfo);
          }
          // }
        })
        .catch((error) => {
          this.loading = false;
          console.error("tracking.getOnDutySTaffListFunction-error:", error);
          this.$snotify.error(
            "Get get On Duty Staff List list failed",
            "Error!"
          );
        });
    },

    resetLocationService() {
      this.dutyTrackingOnInit()
    },

    getLocationByStaffId(data) {
      let dutyInfo = [];
      let staff = data;
      staff["location"] = {};
      staff["location"]["lat"] = data.details.geoLocation[1] ? element.details.geoLocation[1] : "";
      staff["location"]["lng"] = data.details.geoLocation[0];
      staff["lat"] = data.details.geoLocation[1] ? element.details.geoLocation[1] : "";
      staff["lng"] = data.details.geoLocation[0];
      dutyInfo.push(staff);
      if (dutyInfo.length > 0) {
        eventBus.$emit("trackingLocation", dutyInfo);
      }
    },

    getCityList() {
      const params = {};
      this.cityList = [];
      let cities = [];
      this.$cityRepository
        .collectionCitysList(params)
        .then((res) => {
          this.loading = false;
          if (res.data.response.length > 0) {
            res.data.response.forEach((element) => {
              if (element.status === true) {
                cities.push({
                  name:
                    element.cityName.length > 25
                      ? element.cityName.slice(0, 25) + "..."
                      : element.cityName,
                  value: element._id,
                });
              }
            });
            this.cityList = cities;
            this.city = this.cityList[0];
            this.getOnDutyStaffList(this.$store.state.auth.cityId.value);
            this.$refs.surveyTable.refresh();
          }

        })
        .catch((error) => {
          this.loading = false;
          console.error("cities.requestFunction-error:", error);
          this.$snotify.error("Get cities list failed", "Error!");

        });
    },
    onLoaded() {
    this.surveyTable = this.$refs.surveyTable;
  },
    onCitySelect(city) {
      this.getOnDutyStaffList(city.value);
      this.$refs.surveyTable.refresh()
    },
    dutyTrackingOnInit() {
      if (!this.$store.state.auth.user.cityId) {
        this.getCityList()
      } else {
        this.cityAdmin = true;
        let cityId = this.$store.state.auth.user.cityId._id;   
        this.getOnDutyStaffList(cityId);
      }
    }
  },
   computed: {
        addButtonClass() {
   
            if (this.surveyTable) {
                return this.surveyTable.count > this.surveyTable.limit ||
                    this.surveyTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
        // ...mapState({
        //     user: (state) => state.auth.user,
        // }),
    },
  mounted() {
    this.parameters.cityId = this.$store.state.auth.cityId.value
        eventBus.$on('cityIdChanged', this.onCitySelect);
    this.staffLocationRefresh = setInterval(() => {
      this.dutyTrackingOnInit()
    }, 2 * 60 * 1000) 

  },

  created() {
    this.dutyTrackingOnInit()
  },

  beforeDestroy() {
    clearInterval(this.staffLocationRefresh),
    eventBus.$off('cityIdChanged', this.onChecked);
  }
};
</script>

<style>
.test-table {
  margin-left: 80px;
}

.subcattable table {
  margin-left: 0px;
}

.subcattable table td,
.subcattable table th {
  border: 1px solid #f4f4f4;
}

.subcattable table tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}

.subcattable table tr:hover {
  background-color: #f2fff9 !important;
}

.edit_del_btn {
  border: 0;
  background-color: transparent;
  color: #0f6940;
}

.subcattable table tr td:last-child {
  width: 200px;
}

.city_dropdown {
  display: flex;
  justify-content: space-between;
  margin: 20px 0px;
}

.city_rel_class {
  width: 150%;
}

.monitor {
  overflow: auto;
  height: 368px
}

.driver-data .monitor {
  height: 290px !important;
}

.monitor table {
  margin: 0;
  position: relative;
  top: -2px
}

.monitor table thead {
  position: sticky;
  top: -1px;
}

.table-body-details {
  overflow: auto;
  height: 290px !important;
}

.monitoring_wrp .vue-map-container {
  height: calc(100vh - 235px) !important;
}

.monitoring_wrp .table-responsive {
    height: calc(100vh - 342px);
}



@media(max-width:1199px) {
  .monitoring_wrp .vue-map-container {
    height: calc(100vh - 260px) !important;
  }
}

@media(max-width:768px) {
  .monitoring_wrp {
    height: calc(100vh - 235px);
    overflow: auto;
  }

  .monitor table {
    width: 100%;
  }
}

@media(max-width:767px) {
  .city_dropdown {
    margin: 10px 0px;
    flex-direction: column-reverse;
  }

  .city_rel_class {
    width: 100% !important;
    margin-top: 10px;
  }
}
</style> 



// WEBPACK FOOTER //
// monitoring.vue?6a2113da